import * as React from "react"
import * as ReactDOM from "react-dom"
import {createStore, applyMiddleware} from "redux"
import reduxThunk from "redux-thunk"
import {connect} from "react-redux"
import {CallJs} from "../lib/types"
import {makeReducer} from "../lib/utils"
import {Get_Cookie} from "./cookie";
import {Dashboard, VisitsColors, SourceColors} from "./dashboard/presentation";
import {isDashboardAction} from "./dashboard/action";
import {reducer} from "./dashboard/reducer";
import {
	CallbackProps, DashboardState, mapDispatchToProps, mapStateToProps, OwnProps,
	ValueProps
} from "./dashboard/app";

type DashboardCallJsParams = VisitsColors & SourceColors & {
	getDashboardDataURI: string
	getKeywordsURI: string
	fromDate: number|null,
	toDate: number|null
	hasEventTracking: boolean
	hasEcommerceTracking: boolean
}

type DashboardFullParams = {
	fromDate: Date|null,
	toDate: Date|null
}

const hydrateParams = (plain: DashboardCallJsParams): DashboardFullParams => ({
	fromDate: plain.fromDate ? new Date(1000*plain.fromDate) : null,
	toDate: plain.toDate ? new Date(1000*plain.toDate) : null,
})

export const dashboardCallJs: CallJs<DashboardCallJsParams> = (replacer, params) => {
	const usefulParams = hydrateParams(params)

	const today = new Date()
	const lastYear = new Date()
	lastYear.setFullYear(today.getFullYear()-1)
	const initialState: DashboardState = {
		activeTab: "traffic sources",
		loading: "done",
		fromDate: usefulParams.fromDate || lastYear,
		toDate: usefulParams.toDate || today,
		includesNewVisitors: false,
		includesReturningVisitors: false,
		visits: [],
		times: [],
		overviewing: undefined,
		keywords: {},
		sources: null,
		tabs: {
			"traffic sources": {
				data: [],
				typePlaceholder: {i: 0, medium: '', avgTimeOnSite: 0, visits: 0, source: '', highlight: false},
				pagination: {label: 'traffic sources', limit: 10, page: 1}
			},
			"keywords": {
				data: [],
				typePlaceholder: {i: 0, avgTime: 0, highlight: false, keyword: '', visitsTotal: ''},
				pagination: {label: 'keywords', limit: 10, page: 1}
			},
			"content": {
				data: [],
				typePlaceholder: {i: 0, time: 0, pageviewsTotal: 0, url: '', greytitle: '', maintitle: '', visitsTotal: ''},
				pagination: {label: 'content', limit: 10, page: 1}
			},
			"event detail": {
				data: [],
				typePlaceholder: {i: 0, time: 0, pageviewsTotal: 0, url: '', greytitle: '', maintitle: '', visitsTotal: ''},
				pagination: {label: 'event detail', limit: 10, page: 1}
			},
			"ecommerce": {
				data: [],
				typePlaceholder: {i: 0, uniquePurchasesTotal: 0, itemRevenueTotal: 0, productName: ''},
				pagination: {label: 'ecommerce', limit: 10, page: 1}
			}
		}
	}

	const store = createStore<DashboardState>(
		makeReducer(isDashboardAction, reducer, initialState),
		applyMiddleware(reduxThunk)
	)

	const DashboardApp = connect<
		ValueProps,
		CallbackProps,
		OwnProps,
		DashboardState
	>(mapStateToProps, mapDispatchToProps)(Dashboard)

	const props = {
		visitsColor: params.visitsColor,
		returningVisitsColor: params.returningVisitsColor,
		newVisitsColor: params.newVisitsColor,
		pageviewsColor: params.pageviewsColor,
		directColor: params.directColor,
		referringColor: params.referringColor,
		searchColor: params.searchColor,
		otherColor: params.otherColor,
		getDashboardDataURI: params.getDashboardDataURI,
		getKeywordsURI: params.getKeywordsURI,
		hasEventTracking: params.hasEventTracking,
		hasEcommerceTracking: params.hasEcommerceTracking,
		cookieName,
		store
	}

	const div = document.createElement("div")
	replacer(div)
	ReactDOM.render(<DashboardApp {...props} />, div)

	const dispatchers = mapDispatchToProps(store.dispatch, props)

	const segmentsCookie = Get_Cookie(cookieName)
	switch (segmentsCookie) {
		case 'newvisits':
			dispatchers.setNewVisitors(true)
			break
		case 'segments':
			dispatchers.setNewVisitors(true)
			dispatchers.setReturningVisitors(true)
			break
		case 'returnvisits':
			dispatchers.setReturningVisitors(true)
			break
	}

	dispatchers.updateVisitsData()
}

const cookieName = 'segments_values'



// WEBPACK FOOTER //
// ./src/analytics/dashboard.tsx